const focusOnFirstInteractiveEl = (container: HTMLElement | null) => {
  if (!container) return;
  const focusableElements = container.querySelectorAll<HTMLElement>(
    "button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])"
  );
  focusableElements[0]?.focus();
};

export default focusOnFirstInteractiveEl;
